module.exports = __webpack_public_path__ + "./fonts/DMSans-Regular.d11e1e.eot";